<template>
  <base-table-wrapper>
    <template #top-buttons>
      <router-link :to="{ name: 'ClientTypeCreate' }" class="mb-1 btn btn-sm btn-primary float-right">{{$t('buttons.create')}}</router-link>
    </template>
    <template #body>
        <div v-if="isLoading">
          <Loader size="lg"></Loader>
        </div>
        <div v-else-if="!isLoading && items.length < 1">
          {{ $t('views.user.list.noUser') }}
        </div>
        <div v-else>
            <table class="table table-sm table-striped table-hover">
              <thead>
              <tr>
                <th>{{$t('views.consents.list.state')}}</th>
                <th>{{$t('global.title')}}</th>
                <th>{{$t('views.user.list.role')}}</th>
                <th colspan="4" />
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="item in items"
                :key="item['@id']">
                <td class="text-left">
                  <i v-if="item.state" style="color: #28a745" class="fa fa-check-circle"></i>
                  <i v-else class="fa fa-times-circle" style="color: #dc3545"></i>
                </td>
                <td>
                  <router-link
                    v-if="item"
                    :to="{name: 'ClientTypeShow', params: { id: item['@id'] }}">
                  </router-link> {{ item.title }}
                </td>
                <td class="text-left">
                  {{item.roles[0]}}
                </td>
                <td>
                  <b-dropdown
                    v-if="ableToManageUsers"
                    class="float-right"
                    size="sm" variant="link"
                    right text="Right align"
                    toggle-class="text-decoration-none" no-caret>
                    <template #button-content>
                      <i class="fa fa-bars fa-lg"></i>
                    </template>
                    <b-dropdown-item
                      @click="$router.push({name: 'ClientTypeUpdate', params: { id: item['@id'] }})">
                      <i class="fa fa-edit fa-lg"></i>
                      {{ $t('buttons.edit') }}
                    </b-dropdown-item>
                    <b-dropdown-item v-if="item.state === 1"
                      @click="archiveItem(item['@id'])">
                      <i class="fa fa-key fa-lg"></i>
                      {{ $t('buttons.archive') }}
                    </b-dropdown-item>
                    <b-dropdown-item v-else
                      @click="unArchiveItem(item['@id'])">
                      <i class="fa fa-key fa-lg"></i>
                      {{ $t('buttons.moveFromArchive') }}
                    </b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
              </tbody>
            </table>
            <pagination
              v-if="view"
              :view="view"
              @getPageNumber="getList($event.page, $event.itemsPerPage)"
            ></pagination>
        </div>
    </template>
  </base-table-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'
import { checkPermission } from '@/utils/checkRoles'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import addParamsToQuery from '@/utils/addParamsToQuery'
import { archive, unArchive } from '@/utils/archive'

export default {
  components: {
    Loader,
    Pagination,
    BaseTableWrapper
  },

  data () {
    return {
    }
  },
  computed: {
    ableToManageUsers () {
      return checkPermission('appConfiguration', 'AppConfiguration')
    },
    ...mapGetters({
      deletedItem: 'clienttype/del/deleted',
      error: 'clienttype/list/error',
      items: 'clienttype/list/items',
      isLoading: 'clienttype/list/isLoading',
      view: 'clienttype/list/view'
    })
  },

  created () {
    this.getList()
  },
  watch: {
    searchParams: {
      deep: true,
      handler (val) {
        this.getList()
      }
    }
  },
  methods: {
    getList (pageNum = 1, itemsPerPage = undefined) {
      let params = { '_page': pageNum, itemsPerPage: itemsPerPage }
      let url = addParamsToQuery('client_types', params)
      this.getPage(url)
    },
    archiveItem (id) {
      archive(id, () => { this.getList(1) })
    },
    unArchiveItem (id) {
      unArchive(id, () => { this.getList(1) })
    },
    ...mapActions({
      getPage: 'clienttype/list/default'
    })
  }
}
</script>
